/* assets/single-flower-poster-palette.js
   Color palette for Single Flower Poster.
   Loads colors from an external JSON file, with inline fallback.

   Expected JSON format:
   {
     "colors": [
       { "hex": "#FFFFFF", "name": "White", "default": true },
       { "hex": "#D4D4D4", "name": "Gray" }
     ]
   }

   Usage in Liquid:
     <script src="{{ 'single-flower-poster-palette.js' | asset_url }}"></script>
     <script>
       // window.SingleFlowerPosterPalette.colors is available after load
     </script>
*/

(function (root) {
  // Inline fallback palette (gray + white)
   var FALLBACK_COLORS = [
    { hex: "#ebebeb", name: "Gray", default: true },
    { hex: "#FFFFFF", name: "White" },
  ];

  root.SingleFlowerPosterPalette = {
    colors: FALLBACK_COLORS.slice(),
    loaded: false,
  };

  /**
   * Load palette from a JSON URL.
   * Call this from your Liquid section after the script loads:
   *   SingleFlowerPosterPalette.loadFromUrl('{{ "flower-palette.json" | asset_url }}');
   *
   * @param {string} url - URL to the JSON palette file
   * @returns {Promise<void>}
   */
  root.SingleFlowerPosterPalette.loadFromUrl = function (url) {
    if (!url) return Promise.resolve();

    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error("Palette fetch failed: " + res.status);
        return res.json();
      })
      .then(function (data) {
        if (Array.isArray(data.colors) && data.colors.length > 0) {
          root.SingleFlowerPosterPalette.colors = data.colors;
          root.SingleFlowerPosterPalette.loaded = true;
        }
      })
      .catch(function (err) {
        console.warn("[SingleFlowerPosterPalette] Using fallback palette:", err.message);
      });
  };
})(typeof self !== "undefined" ? self : this);
